import { downloaderConstants } from "./downloader.constants";

export function downloader(state = {}, action) {
    let deletedFiles;
    let updatedFileList;

    switch (action.type) {
        case downloaderConstants.FETCH_FILE_LIST_REQUEST:
            return {
                ...state,
                errorMessage: null,
                loading: true,
                dataPage: null,
                fileList: null,
            };

        case downloaderConstants.FETCH_FILE_LIST_SUCCESS:
            return {
                ...state,
                dataPage: action.result,
                fileList: action.result.content,
                errorMessage: null,
                // Whether the list on screen came from an answered request. "No files found" is only true if
                // one did; a failed request also leaves the list empty, and saying the folder is empty then
                // sends someone looking for a file that is there.
                listLoaded: true,
                loading: false,
            };

        case downloaderConstants.FETCH_FILE_LIST_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                listLoaded: false,
                loading: false,
            };

        case downloaderConstants.GET_DOWNLOAD_REQUEST_REQUEST:
            return {
                ...state,
                subloading: true,
                linkRequestErrorMessage: null,
                downloadRequest: null,
            };

        case downloaderConstants.GET_DOWNLOAD_REQUEST_SUCCESS:
            return {
                ...state,
                subloading: false,
                downloadRequest: action.result,
            };

        case downloaderConstants.GET_DOWNLOAD_REQUEST_FAILURE:
            return {
                ...state,
                subloading: false,
                linkRequestErrorMessage: action.errorMessage,
            };

        case downloaderConstants.CLEAR_DOWNLOAD_REQUEST:
            return {
                ...state,
                linkRequestErrorMessage: null,
                downloadRequest: null,
            };

        case downloaderConstants.DELETE_PLATFORM_FILES_REQUEST:
            return {
                ...state,
                deleteLoading: true,
                errorMessage: null,
                deletionErrorMessage: null,
            };

        case downloaderConstants.DELETE_PLATFORM_FILES_SUCCESS:
            deletedFiles = action.result;

            deletedFiles.forEach((item) => {
                updatedFileList = removeDeletedFileFromFileList(item.externalUUID, state.fileList);
            });

            return {
                ...state,
                deleteLoading: false,
                deletionModal: false,
                errorMessage: null,
                deletionErrorMessage: null,
                fileList: updatedFileList,
                fileToDeleteUUID: null,
            };

        case downloaderConstants.DELETE_PLATFORM_FILES_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                errorMessage: action.errorMessage,
                deletionErrorMessage: action.errorMessage,
            };

        case downloaderConstants.SET_DOWNLOAD_LINK_MODAL_PROPERTIES:
            return {
                ...state,
                downloadLinkId: action.id,
                downloadFileName: action.fileName,
            };

        case downloaderConstants.TOGGLE_DOWNLOAD_LINK_MODAL:
            return {
                ...state,
                downloadButtonModal: action.show,
            };

        case downloaderConstants.TOGGLE_DELETE_DOWNLOAD_MODAL:
            return {
                ...state,
                deletionModal: !state.deletionModal,
                fileToDeleteUUID: action.fileUUID,
            };

        case downloaderConstants.DELETE_PLATFORM_FILE_REQUEST:
            return {
                ...state,
                deletionErrorMessage: null,
                deletionLoading: true,
            };

        case downloaderConstants.DELETE_PLATFORM_FILE_SUCCESS:
            deletedFiles = action.result;

            deletedFiles.forEach((item) => {
                updatedFileList = removeDeletedFileFromFileList(item.externalUUID, state.fileList);
            });

            return {
                ...state,
                fileList: updatedFileList,
                deletionLoading: false,
                deletionModal: false,
                fileToDeleteUUID: null,
            };

        case downloaderConstants.DELETE_PLATFORM_FILE_FAILURE:
            return {
                ...state,
                deletionLoading: false,
                deletionErrorMessage: action.errorMessage,
            };

        case downloaderConstants.FETCH_PLATFORM_FILE_INTEGRATIONS_REQUEST:
            return {
                ...state,
                initialLoading: true,
                integrations: null,
                initialLoadingErrorMessage: null,
            };

        case downloaderConstants.FETCH_PLATFORM_FILE_INTEGRATIONS_SUCCESS:
            return {
                ...state,
                initialLoading: false,
                integrations: action.result,
            };

        case downloaderConstants.FETCH_PLATFORM_FILE_INTEGRATIONS_FAILURE:
            return {
                ...state,
                initialLoading: false,
                initialLoadingErrorMessage: null,
            };

        case downloaderConstants.FETCH_PLATFORM_FILE_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                initialLoading: true,
                organizations: null,
                initialLoadingErrorMessage: null,
            };

        case downloaderConstants.FETCH_PLATFORM_FILE_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                initialLoading: false,
                organizations: action.result,
            };

        case downloaderConstants.FETCH_PLATFORM_FILE_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                initialLoading: false,
                initialErrorMessage: null,
            };

        default:
            return state;
    }

    function removeDeletedFileFromFileList(fileUUID, fileList) {
        if (!fileList) {
            return fileList;
        }

        let i = fileList.findIndex((item) => {
            return (item.externalUUID = fileUUID);
        });

        if (i > -1) {
            fileList.splice(i, 1);
        }

        return fileList;
    }
}
